module.exports = __webpack_public_path__ + "@/assets/img/video-camera.d04d42a7.svg";